import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Form,
  Tab,
  Menu,
  Label,
  Button,
  Popup,
  Comment,
  Icon,
  Input,
  Message
} from 'semantic-ui-react';
import { enums } from '../../helpers';
import { BankDetails, Transactions } from '../../components';
import moment from 'moment';

import 'semantic-ui-css/components/modal.min.css';
import 'semantic-ui-css/components/dimmer.min.css';
import 'semantic-ui-css/components/transition.min.css';
import 'semantic-ui-css/components/tab.min.css';
import 'semantic-ui-css/components/menu.min.css';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/form.min.css';
import 'semantic-ui-css/components/dropdown.min.css';
import 'semantic-ui-css/components/message.min.css';
import 'semantic-ui-css/components/comment.min.css';
import 'semantic-ui-css/components/table.min.css';

import './ReviewRefundRequestModal.css';

const statusOptions = [
  {
    key: "NEW",
    value: "NEW",
    text: "New"
  }, {
    key: "REQUESTED",
    value: "REQUESTED",
    text: "Requested",
    disabled: true
  }, {
    key: "RETURNED",
    value: "RETURNED",
    text: "Returned",
    disabled: true
  }, {
    key: "APPROVED",
    value: "APPROVED",
    text: "Approved",
    disabled: true
  }, {
    key: "REJECTED",
    value: "REJECTED",
    text: "Rejected",
    disabled: true
  }, {
    key: "COMPLETED",
    value: "COMPLETED",
    text: "Completed",
    disabled: true
  }
];

const priorityOptions = [
  {
    key: "HIGH",
    value: "HIGH",
    text: <span className="priority-icon-form"><Icon name="angle double up" color="red" /> High</span>
  }, {
    key: "NORMAL",
    value: "NORMAL",
    text: <span className="priority-icon-form"><Icon name="angle double down" color="green" /> Normal</span>
  }
];

export default class NewRefundRequestModal extends Component {
  static propTypes = {
    updateRequest: PropTypes.func,
    readOnly: PropTypes.bool,
    submitComment: PropTypes.func,
    initialValues: PropTypes.obj,
    addComment: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      comment: '',
    }
  }

  componentDidMount() {
    if (this.props.initialValues && this.props.initialValues.msisdn) {
      this.props.getRefundsCount(this.props.initialValues.msisdn)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.initialValues && this.props.open !== prevProps.open) {
      const { msisdn, oc, srvcId, refundMethod } = this.props.initialValues;
      this.props.getRefundsCount(msisdn)
      if (refundMethod === 'api') this.props.getTransactions(msisdn, oc, srvcId)
    }
    if (
      this.props.initialValues &&
      prevProps.initialValues &&
      this.props.initialValues.refundMethod &&
      prevProps.initialValues.refundMethod &&
      this.props.initialValues.refundMethod !== prevProps.initialValues.refundMethod &&
      this.props.initialValues.refundMethod === 'api'
    ) {
      const { msisdn, oc, srvcId } = this.props.initialValues;
      this.props.getTransactions(msisdn, oc, srvcId)
    }
  }

  clearComment = () => this.setState({ comment: '' })

  close = () => {
    this.clearComment();
    this.props.close();
  }

  handleSubmit = (status) => () => {
    this.props.updateStatus(this.props.open, status);
    this.close();
  }

  submitComment = () => {
    this.props.addComment(this.props.open, this.state.comment)
    this.clearComment();
  }

  onItemChange = (field) => (e, { value }) => this.setState({ [field]: value })

  handleUpload = (event) => {
    const data = new FormData();
    data.append('file', event.target.files[0])
    event.target.value = null;
    this.props.uploadFiles(this.props.open, data);
  }

  handleImagePaste = (event) => {
    const items = (event.clipboardData  || event.originalEvent.clipboardData).items;

    let blob = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") === 0) {
        blob = items[i].getAsFile();
      }
    }
    if (blob) {
      const data = new FormData();
      data.append('file', blob)
      this.props.uploadFiles(this.props.open, data);
    }
  }

  renderProcessingFeeField = () =>{
    const {refundMethod, amount} = this.props.initialValues;
    if(refundMethod.toLowerCase() === "topup"){
      return <Form.Input
      label="Processing Fee"
      readOnly
      disabled
      value={amount.processingFee}
      fluid      
    />
    }

    return "";
  }
  

  render() {
    const countries = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryName
    }), {}) : {};

    const countryOptions = Object.keys(countries).map(Number).map(countryId => ({ key: countryId, value: countryId, text: countries[countryId] }));
    const operatorOptions = this.props.initialValues ? this.props.operators.filter(operator => operator.countryId === this.props.initialValues.countryId).map(operator => ({ key: operator.oc, value: operator.oc, text: operator.operatorName })) : [];
    const serviceOptions = this.props.initialValues && this.props.operators ? this.props.operators.find(operator => operator.oc === this.props.initialValues.oc).services.map(service => ({ key: service.id, value: service.id, text: service.name })) : [];
    return (
      <Modal
        className="ReviewRefundRequestModal"
        open={this.props.open}
        onClose={this.close}
        mountNode={document.getElementById('root')}
        closeIcon
      >
        <Modal.Header>Review Request</Modal.Header>
        {this.props.initialValues ? <Modal.Content scrolling>
          {this.props.refundCount !== 1 ? <Message
            warning
            size="mini"
            header="Warning"
            content={!this.props.refundCount ? <Icon name='circle notched' loading /> : `this user has ${this.props.refundCount} previous refunds`}
          /> : null }
          <Form className="TicketContent" size='mini' loading={!this.props.initialValues}>
              <div className="former-group">
                <Form.Input
                  value={this.props.initialValues.zendeskTicket}
                  placeholder="Zendesk Ticket"
                  readOnly
                  disabled
                  label="ZenDesk Ticket #"
                />
              </div>

              <div className="former-group">
                <Form.Dropdown
                  label="Country"
                  value={this.props.initialValues.countryId}
                  selection
                  readOnly
                  disabled
                  fluid
                  options={countryOptions}
                />
                <Form.Dropdown
                  label="Operator"
                  value={this.props.initialValues.oc}
                  selection
                  readOnly
                  disabled
                  fluid
                  options={operatorOptions}
                />
                <Form.Dropdown
                  label="Service"
                  value={this.props.initialValues.srvcId.toString()}
                  selection
                  readOnly
                  disabled
                  fluid
                  options={serviceOptions}
                />
              </div>
              <div className="former-group">
                  <Form.Input
                      fluid
                      label="Entity"
                      readOnly
                      disabled
                      value={this.props.initialValues.entity}
                  />
                  <Form.Dropdown
                      label={{ children: [
                        "Refund Method",
                        ['api', 'bill_payment'].includes(this.props.initialValues.refundMethod) &&
                        ['APPROVED', 'REQUESTED'].includes(this.props.initialValues.status) &&
                        this.props.switch &&
                        (this.props.initialValues.countryId === 128 || this.props.initialValues.countryId === 32) ?
                          <Popup
                            position='right center'
                            trigger={
                              <Button
                                style={{pointerEvents: 'auto', marginLeft: '10px'}}
                                loading={this.props.switching}
                                disabled={this.props.switching}
                                icon='sync alternate'
                                onClick={() => this.props.switch(this.props.open)}
                                size='mini'
                              />
                            }
                            content="switch method"
                            inverted
                          /> :
                          null
                      ]}}
                      value={this.props.initialValues.refundMethod}
                      selection
                      readOnly
                      disabled
                      fluid
                      options={Object.keys(enums.refundMethods).map(method => ({ key: method, value: method, text: enums.refundMethods[method] }))}
                  />
                  <BankDetails
                      entity={this.props.initialValues.entity}
                      refundMethod={this.props.initialValues.refundMethod}
                      initialValues={this.props.initialValues.bankDetails}    
                      readOnly                 
                  />
                  {
                    this.props.initialValues.refundMethod === 'api' ?
                    <Transactions
                      transactions={this.props.transactions}
                      makeRefund={this.props.makeRefund}
                      makeRefunds={this.props.makeRefunds}
                      msisdn={this.props.initialValues.msisdn}
                      refunding={this.props.refunding}
                      oc={this.props.initialValues.oc}
                      role={this.props.type}
                      status={this.props.initialValues.status}
                      currency={this.props.initialValues.amount.currency}
                      ticketId={this.props.open}
                      loading={this.props.loadingTransactions}
                    /> :
                    null
                  }
              </div>
              <div className="former-group">
              <Form.Dropdown
                label="Priority"
                value={this.props.initialValues.priority}
                selection
                fluid
                readOnly
                disabled
                options={priorityOptions}
              />
              <Form.Dropdown
                label="Status"
                value={this.props.initialValues.status}
                selection
                fluid
                readOnly
                disabled
                options={statusOptions}
              />
              </div>
              <div className="former-group">
              <Form.Input
                label="MSISDN"        
                readOnly        
                value={this.props.initialValues.msisdn}
              />
              <Form.Dropdown
                label="Currency"
                value={this.props.initialValues.amount.currency}
                selection
                readOnly
                disabled
                fluid
                options={Object.keys(enums.currencies).map(currency => ({ key: currency, value: currency, text: enums.currencies[currency] }))}
              />
              <Form.Input
                label={'Amount'}
                readOnly
                disabled
                value={this.props.initialValues.amount.value}
              />
              {this.renderProcessingFeeField()}
              </div>

              <div className="former-group">
              <Form.Input
                label="Name"
                readOnly
                disabled
                value={this.props.initialValues.name}
              />
              <Form.Input
                label="Email"                
                disabled
                value={this.props.initialValues.email}
              />
              </div>
          </Form>
            <Tab
                className="DetailsTab"
                panes={[{
                    menuItem: <Menu.Item key='comments'>Comments<span className="tab-value">&nbsp;({this.props.initialValues.comments.length})</span></Menu.Item>,
                    render: () => <Tab.Pane>
                        <Comment.Group>
                            {this.props.initialValues.comments.length ? this.props.initialValues.comments.map(comment => <Comment>
                                <Comment.Content>
                                  <div className="comment-title-wrapper clearfix">
                                    <Comment.Author as='span'>{comment.user.email}</Comment.Author>
                                    <Comment.Metadata>
                                        <div>{moment(comment.date).format('YYYY-MM-DD HH:mm')}</div>
                                    </Comment.Metadata>
                                  </div>
                                    <Comment.Text>{comment.comment}</Comment.Text>
                                </Comment.Content>
                            </Comment>) : 'No comments yet'}
                            <Form reply size="mini">
                                <Form.TextArea className="reply-textarea" onChange={this.onItemChange('comment')} value={this.state.comment} />
                                <div className="button-reply-wrapper"><Button className="button-reply" onClick={this.submitComment}>Reply</Button></div>
                            </Form>
                        </Comment.Group>
                    </Tab.Pane>
                }, {
                    menuItem: <Menu.Item key='history'>History <span className="tab-value">&nbsp;({this.props.initialValues.history.length})</span></Menu.Item>,
                    render: () => <Tab.Pane>
                        <Comment.Group>
                            <div className="history-widget">
                            {this.props.initialValues.history.map(item =>
                                <Comment>
                                    <Comment.Content>
                                        <div className="comment-title-wrapper clearfix">
                                        <Comment.Author as='span'>{item.user.email}</Comment.Author>
                                        <Comment.Metadata>
                                            <div>{moment(item.date).format('YYYY-MM-DD HH:mm')}</div>
                                        </Comment.Metadata>
                                        </div>
                                        <Comment.Text>{item.change.map(item => {
                                            return (<Label size="mini" className="label-blue">{item.field}: {item.prevValue} => {item.newValue}</Label>)
                                        })}</Comment.Text>
                                    </Comment.Content>
                                </Comment>) }</div>
                        </Comment.Group>
                    </Tab.Pane>
                }, {
                    menuItem: <Menu.Item key='files'>Files <span className="tab-value">&nbsp;({this.props.initialValues.attachments.length})</span></Menu.Item>,
                    render: () => <Tab.Pane>
                        <Label as="label" basic htmlFor="upload" size="mini" disabled={this.props.uploading}>
                          <Button
                            icon="upload"
                            label="Select File"
                            labelPosition="right"
                            size="mini"
                            disabled={this.props.uploading}
                            loading={this.props.uploading}
                          />
                          <input hidden id="upload" type="file" onChange={this.handleUpload} disabled={this.props.uploading} />
                        </Label>
                        <Input size="mini" style={{ marginTop: '20px' }} placeholder='Or Paste here' onPaste={this.handleImagePaste} disabled={this.props.uploading} loading={this.props.uploading} />
                        <Comment.Group>
                          {this.props.initialValues.attachments.length ? this.props.initialValues.attachments.map(attachment => <Comment>
                              <Comment.Content>
                                <div className="comment-title-wrapper clearfix">
                                  <Comment.Author as='span'>{attachment.user.email}</Comment.Author>
                                  <Comment.Metadata>
                                      <div>{moment(attachment.date).format('YYYY-MM-DD HH:mm')}</div>
                                  </Comment.Metadata>
                                </div>
                                  <Comment.Text><a href={attachment.url}>{attachment.fileName}</a></Comment.Text>
                              </Comment.Content>
                          </Comment>) : 'No files yet'}
                        </Comment.Group>
                    </Tab.Pane>
                }
                ]}
            />

        </Modal.Content> : null }
          { this.props.type !== 'requestor' ? <div className="modaler-footer">
              {this.props.type === 'manager' && this.props.initialValues && this.props.initialValues.status === 'APPROVED' ? <Button.Group className="Actions">
              <div className="modaler-footer__item">
                  <Form.Button onClick={this.handleSubmit('RETURNED')}>Return</Form.Button>
              </div>
              <div className="modaler-footer__item">
                  <Form.Button primary onClick={this.handleSubmit('COMPLETED')}>Process</Form.Button>
              </div>
            </Button.Group> : this.props.type === 'manager' && this.props.initialValues && (this.props.initialValues.status === 'COMPLETED' || this.props.initialValues.status === 'REJECTED') ? <Button.Group className="Actions">
              <div className="modaler-footer__item">
                <Form.Button onClick={this.close}>Cancel</Form.Button>
              </div>
              <div className="modaler-footer__item">
                  <Form.Button primary onClick={this.handleSubmit('RETURNED')}>RE-OPEN</Form.Button>
              </div>
            </Button.Group> : this.props.type === 'manager' ? null : <Button.Group className="Actions">
              <div className="modaler-footer__item">
                <Form.Button secondary onClick={this.handleSubmit('RETURNED')}>Return</Form.Button>
              </div>
              <div className="modaler-footer__item">
                  <Form.Button primary onClick={this.handleSubmit('APPROVED')}>Approve</Form.Button>
              </div>
              <div className="modaler-footer__item">
                <Form.Button secondary onClick={this.handleSubmit('REJECTED')}>Reject</Form.Button>
              </div>
              </Button.Group>
              }
          </div> : null }
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReviewRefundRequestModalComponent/ReviewRefundRequestModal.js